<ion-button *ngIf="!this.readonly" class="btn2 mt-1 mb-2 mr-2" (click)="AdjuntarArchivo()"><ion-icon name="add-circle-outline" class="mr-1"></ion-icon>Adjuntar archivo</ion-button>
<ion-button *ngIf="!this.readonly && !DisallowPhotosWithoutGPSMetadata" class="btn2 mt-1 mb-2 mr-2" (click)="HacerFoto()"><ion-icon name="camera-outline" class="mr-1"></ion-icon>Hacer foto</ion-button>
<ion-button *ngIf="!this.readonly" class="btn2 mt-1 mb-2 mr-2" (click)="modalQRFotos.isOpen = true"><ion-icon name="phone-portrait-outline" class="mr-1"></ion-icon>Hacer foto desde el móvil</ion-button>
<ion-button class="btn2 btnColorSecondary mt-1 mb-2 mr-2" (click)="sincronizarFotos()"><ion-icon name="sync" class="mr-1"></ion-icon>Sincronizar</ion-button>
<div class="containerPhoto" *ngIf="(FotosSubject | async) != null && HayFotos(FotosSubject | async)">
  <ng-container *ngFor="let foto of FotosSubject | async">
    <ng-container *ngIf="(Categoria == null && foto.Categoria == null) || (foto.Categoria != null && foto.Categoria == Categoria)">
      <div class="position-relative">

        <a [href]="foto.FotoData" [attr.data-fancybox]="'gallery' + (Categoria != null ? Categoria : '_generales')">
          <img #imgFoto [src]="foto.FotoData" />
        </a>
        <div class="contentButton">
          <!-- <ion-button class="boxDelete" *ngIf="foto.HasGPSMetadataObservable != null ? (foto.HasGPSMetadataObservable | async) : false">GPS</ion-button>
          <ion-button class="boxDelete" (click)="obtenerInformacionImagen(imgFoto); $event.preventDefault(); $event.stopPropagation()">Info</ion-button> -->
          <ion-button color="primary" class="boxDelete" (click)="mdlEditar.isOpen = true;">  <img alt="pen" src="/assets/pencil.svg" class="img-fluid d-md-none mr-0" width="17" style="padding: 1px;"><span class="d-none d-md-block">Marcar</span></ion-button>
          <ion-button *ngIf="!this.readonly" color="danger" class="boxDelete" (click)="EliminarFoto(foto)"><ion-icon name="trash" class="d-md-none mr-0"></ion-icon><span class="d-none d-md-block ">Eliminar</span></ion-button>
        </div>
        <div class="contentButton contentButtonBottom">
          <ion-button class="boxDelete boxBtnInfoPicture" (click)="obtenerInformacionImagen(imgFoto); $event.preventDefault(); $event.stopPropagation()">
            <span class="iconInfoGPS" *ngIf="foto.HasGPSMetadataObservable != null ? (foto.HasGPSMetadataObservable | async) : false">
              <ion-icon name="locate"></ion-icon> GPS
            </span>Info
          </ion-button>
          
        </div>
        <div class="altImg">
          <span>{{foto.FileName | removeFileExtension}}</span>
          <img (click)="renameFoto(foto)" alt="pen" src="/assets/pencil.svg" class="img-fluid mr-0" width="17" style="padding: 1px;">
        </div>
    
        <ion-modal class="modalCustom modalEditorFoto" #mdlEditar (ionModalDidDismiss)="mdlEditar.isOpen = false">
          <ng-template>
            <ion-header>
              <ion-toolbar>
                <ion-buttons slot="end">
                  <ion-button (click)="mdlEditar.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
                </ion-buttons>
                <ion-title>Editar</ion-title>
              </ion-toolbar>
            </ion-header>
            <ion-content>
              <fv-canvas-drawing #canvasDrawing [background-image]="foto.FotoData"></fv-canvas-drawing>
            </ion-content>
            <ion-footer>
              <ion-buttons slot="end" class="ml-auto">
                <ion-button class="btn1 ml-auto" (click)="updateFoto(foto, canvasDrawing.toDataUrl()); mdlEditar.dismiss()"><ion-icon name="save" class="mr-2"></ion-icon>Guardar</ion-button>
              </ion-buttons>
            </ion-footer>
          </ng-template>
        </ion-modal>

      </div>
    </ng-container>
  </ng-container>

</div>

<app-take-photo #photo (foto-hecha)="AddFotoCamara($event)"></app-take-photo>

<!-- Modal QR para subir fotos -->
<ion-modal class="modalCustom" #modalQRFotos (ionModalDidDismiss)="modalQRFotos.isOpen = false">
  <ng-template>
    <ng-container *ngIf="modalQRFotos.isOpen">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="modalQRFotos.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
          </ion-buttons>
          <ion-title>Hacer foto desde el móvil</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <div class="d-flex align-items-center justify-content-center h-100 flex-column">
        <div class="">
          <p class="text color2 text-center mb-0">Código QR</p>
          <p class="titleh2 mx-auto col-md-9 text-center mb-3">Escanee el siguiente código desde el móvil para subir nuevas fotos</p>
        </div>
        <div class="btnqr">
          <qrcode class="noselect" [style.textAlign]="'center'" [qrdata]="getURLQRFotos()" [width]="250"></qrcode>
        </div>
        </div>
      </ion-content>
    </ng-container>
  </ng-template>
</ion-modal>
